// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - HTML Escaping Utilities
// ═══════════════════════════════════════════════════════════════════════════
// Use these whenever interpolating dynamic/user-influenced strings into
// innerHTML to prevent XSS. Verse text, references, account display names,
// emails, photo URLs, and journal/favorite content all flow through here.
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Escape a string for safe interpolation into HTML text/attribute content.
 * Returns an empty string for null/undefined so templates stay clean.
 */
export function escapeHtml(value) {
    if (value === null || value === undefined) return '';
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

/**
 * Escape a URL for use in an href/src attribute, neutralizing dangerous
 * schemes (javascript:, data:, vbscript:). Returns '' if the URL is unsafe.
 */
export function escapeUrl(value) {
    if (value === null || value === undefined) return '';
    const url = String(value).trim();
    // Block dangerous schemes; allow http(s), relative, and protocol-relative.
    if (/^(javascript|data|vbscript):/i.test(url)) return '';
    return escapeHtml(url);
}
